import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

export default function NotFound() {
  return (
    <section className="hero-bg py-24 min-h-[70vh] flex items-center">
      <div className="max-w-xl mx-auto px-5 text-center">
        <div className="text-8xl font-extrabold text-teal-500">404</div>
        <h1 className="mt-3 text-3xl font-extrabold text-slate-900">Seite nicht gefunden</h1>
        <p className="mt-3 text-slate-600">Die Seite, die du suchst, existiert nicht oder wurde verschoben.</p>
        <Link to="/"><Button className="btn-teal rounded-full h-12 px-6 mt-6">Zur Startseite</Button></Link>
      </div>
    </section>
  );
}
